export default __webpack_public_path__ + "static/cocacola-white-76fe92463380213dde639fde3fccfe79.png";